var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusDriverIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.289,
    height: 22.877,
    viewBox: "0 0 18.289 22.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bus-driver-icon-png-14401",
    transform: "translate(-23.378 196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65329",
    "data-name": "Path 65329",
    d: "M31.629-194.379c-1.407.894-2.623,1.681-2.706,1.764-.107.107,0,.227.525.525a3.211,3.211,0,0,0,.834.381,20.81,20.81,0,0,0,2.265-1.407l2.086-1.395-.072-.572c-.072-.632-.167-.918-.286-.918C34.227-196,33.035-195.273,31.629-194.379Z",
    transform: "translate(-4.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65330",
    "data-name": "Path 65330",
    d: "M47.26-179.558c-1.419.966-2.1,1.5-2.122,1.681a2.44,2.44,0,0,0,.811,1.693,2.322,2.322,0,0,0,3.171.048,2.444,2.444,0,0,0,.262-3.517l-.238-.25.489-.334a2.265,2.265,0,0,0,.489-.358,3.372,3.372,0,0,0-.739-.405C49.358-180.988,48.4-180.344,47.26-179.558Z",
    transform: "translate(-19.159 -13.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65331",
    "data-name": "Path 65331",
    d: "M52.559-132.345A1.931,1.931,0,0,0,51.32-131a14.721,14.721,0,0,0,.691,3.493c.632,2.515.8,3.064.966,3.064A7.459,7.459,0,0,0,54.49-125.5c1.395-1.144,1.442-1.216,1.2-2.062l-.119-.393.441.191c.405.167.6.155,2.348-.083,2.217-.3,2.587-.429,2.921-.966a1.155,1.155,0,0,0,.06-1.287c-.405-.775-.727-.834-3.04-.525l-1.49.2-1.55-.954C53.608-132.405,53.251-132.536,52.559-132.345Z",
    transform: "translate(-24.602 -56.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65332",
    "data-name": "Path 65332",
    d: "M124.706-129.258A25.4,25.4,0,0,0,122-126.3c0,.3.238.5.6.5.226,0,.87-.6,2.956-2.73a26.076,26.076,0,0,0,2.646-2.956.508.508,0,0,0-.536-.513A17.311,17.311,0,0,0,124.706-129.258Z",
    transform: "translate(-86.866 -56.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65333",
    "data-name": "Path 65333",
    d: "M23.809-130.82a1.817,1.817,0,0,0-.429.656c-.1.381,2.384,11.8,2.646,12.207.37.572.739.62,4.363.62,3.838,0,4.017-.036,4.434-.87a.977.977,0,0,0,.083-.918,1.474,1.474,0,0,0-.453-.7c-.286-.238-.465-.25-3.219-.25-2.527,0-2.909-.024-2.98-.191-.036-.1-.56-2.444-1.168-5.209-1.073-4.887-1.109-5.031-1.478-5.352A1.3,1.3,0,0,0,23.809-130.82Z",
    transform: "translate(0 -57.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65334",
    "data-name": "Path 65334",
    d: "M68.923-73.056a17.017,17.017,0,0,0-1.514,1.311c-.143.25,0,.5.477.87l.441.334,2.646.036,2.658.036,2.17,2.086c1.2,1.156,2.348,2.193,2.539,2.325a1.341,1.341,0,0,0,2.038-1.395c-.072-.346-.6-.977-2.778-3.3a25.551,25.551,0,0,0-3.123-3.087,8.2,8.2,0,0,0-2.277-.274L70.353-74.2Z",
    transform: "translate(-38.736 -107.281)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusDriverIcon);
export default __webpack_public_path__ + "static/media/bus-driver-icon.178139baae8f1502d70419f6e119a7be.svg";
export { ForwardRef as ReactComponent };